import login from '../../services/login';
import { AppState } from 'react-native';
import moment from 'moment';
import { stopLocationTracking, trackUser } from '../../providers/TrackingProvider/actions';

let backgroundTime = null;
const INACTIVITY_LIMIT = 5 * 60 * 60 * 1000; // 5 hours

function setupBackgroundTrackingWatcher(inActivityTimeout) {
	AppState.addEventListener('change', (nextAppState) => {
		if (nextAppState === 'background') {
			backgroundTime = Date.now();
		} else if (nextAppState === 'active') {
			backgroundTime = null;
		}
	});

	// Periodically check for inactivity
	const intervalId = setInterval(() => {
		if (backgroundTime && (Date.now() - backgroundTime > inActivityTimeout)) {
			stopLocationTracking();
			backgroundTime = null;
			clearInterval(intervalId);
			console.log('Tracking stopped due to 5 hours in background.');
		}
	}, 60 * 1000); // Check every minute
}

export async function trackUserLocation(enable = false) {
	try {

		const user = await login.getUser();
		const config = await login.getGlobalConfig();
		const geofencingAllowed = user?.allowGeofencing === true;
		const shouldTrack = geofencingAllowed && (enable || config?.isBackgroundTracking);

		if (!shouldTrack) {
			console.log("tracking has been stopped");
			await stopLocationTracking();
			return;
		}

		// Defer start if app is not active to avoid FGS start restrictions
		if (AppState.currentState !== 'active') {
			const onActive = async (state) => {
				if (state === 'active') {
					AppState.removeEventListener('change', onActive);
					const timeInterval = config?.timeInterval || 10000; // Default to 10 seconds
					const distanceInterval = config?.distanceInterval || 5; // Default to 10 meters
					await trackUser(timeInterval, distanceInterval);
					setupBackgroundTrackingWatcher(config?.inActivityTimeout || INACTIVITY_LIMIT);
				}
			};
			AppState.addEventListener('change', onActive);
			return;
		}

		console.log("tracking is enable");
		const timeInterval = config?.timeInterval || 10000; // Default to 10 seconds
		const distanceInterval = config?.distanceInterval || 5; // Default to 10 meters
		await trackUser(timeInterval, distanceInterval);

		// Setup inactivity watcher when tracking starts
		setupBackgroundTrackingWatcher(config?.inActivityTimeout || INACTIVITY_LIMIT);
	} catch (error) {
		console.error('Error while tracking:', error);
	}
}
